// Swym Custom Solutions — Retrofete
// Deep-link to a specific wishlist tab via ?tab=sfl or ?tab=wl
// Used by email/SMS flows to open the correct list view directly.
(function () {
  var tabIds = {
    'sfl': 'tab-tabSavedForLater',
    'wl': 'tab-tabWishlist'
  };
  var idToTab = {};
  Object.keys(tabIds).forEach(function (key) {
    idToTab[tabIds[key]] = key;
  });

  var params = new URLSearchParams(window.location.search);
  var tab = (params.get('tab') || '').toLowerCase();
  var targetId = tabIds[tab];

  function syncUrlToTab(tabKey) {
    var url = new URL(window.location.href);
    if (url.searchParams.get('tab') === tabKey) return;
    url.searchParams.set('tab', tabKey);
    window.history.replaceState(null, '', url.toString());
  }

  var deepLinkAchieved = false;
  function settleTab() {
    if (deepLinkAchieved) return;

    if (targetId) {
      var btn = document.getElementById(targetId);
      if (!btn) return;
      if (btn.getAttribute('aria-selected') === 'true') {
        // Deep link has landed -- stop here so a later retry can't fight
        // a manual tab switch the user makes after this point.
        deepLinkAchieved = true;
        syncUrlToTab(tab);
        return;
      }
      btn.click();
      return;
    }

    // An unrecognized ?tab= value was requested (e.g. ?tab=foo) -- leave
    // the URL alone rather than silently coercing it to the default tab.
    if (tab) return;

    // No tab requested at all -- reflect whichever tab Control Center
    // landed on by default, so the address bar always shows ?tab=<id>,
    // matching a manual tab switch, instead of a bare /pages/wishlist on
    // first landing.
    var activeId = Object.keys(idToTab).filter(function (id) {
      var el = document.getElementById(id);
      return el && el.getAttribute('aria-selected') === 'true';
    })[0];
    if (!activeId) return;
    deepLinkAchieved = true;
    syncUrlToTab(idToTab[activeId]);
  }

  // SwymCallbacks fires once Swym's SDK is ready, but the Control Center
  // widget can still be re-rendering its tab DOM after that point, so a
  // single early check can miss the landed state. Retry at increasing
  // delays -- settleTab's deepLinkAchieved check makes each retry a no-op
  // once the tab has actually settled.
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    [50, 300, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(settleTab, delay);
    });
  });

  // Keep the URL in sync when the user manually switches tabs.
  // Registered unconditionally -- must not be gated behind a ?tab= param being present,
  // isTrusted filters out our own programmatic clicks.
  document.addEventListener('click', function (e) {
    if (e.isTrusted === false) return;
    var btn = e.target && e.target.closest
      ? e.target.closest('.swym-storefront-layout-tab-button')
      : null;
    if (!btn) return;
    var newTab = idToTab[btn.id];
    if (!newTab) return;
    syncUrlToTab(newTab);
  });
})();
